import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardIframe from 'src/components/DashboardIframe';
import { hasDashboardAccess } from 'src/utils/dashboardAccess';

const DashboardsView = () => {
  if (!hasDashboardAccess()) {
    return <Navigate to="/api" />;
  }

  return <DashboardIframe path="/dashboards" title="Dados Eventos" />;
};

export default DashboardsView;
